<template>
  <svg :width="width" :height="height" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
    <g stroke="null" id="svg_1" fill-rule="nonzero" fill="currentColor">
      <path stroke="null" fill="#ffffff" id="svg_2" d="m574.301395,746.315262c5.378676,13.613934 14.792321,22.664258 25.530451,22.664258c11.278304,0 21.093716,-9.969198 26.305149,-24.72884l-51.8356,2.064581zm45.366963,-47.260457l-5.144152,-23.394743l-45.001721,-204.65883l-47.385409,17.139485l63.486836,189.030295c-5.494016,4.855803 -9.905761,12.425934 -12.664303,21.539696l46.708749,0.344097zm-431.251433,-4.061881c-8.31215,0 -14.553953,15.932262 -14.553953,35.836056c0,19.911483 6.241802,35.837979 14.555875,35.837979c9.361742,0 14.561642,-15.926495 14.561642,-35.837979c0,-19.903794 -5.1999,-35.836056 -14.561642,-35.836056m32.377787,19.91725c0.828524,4.82889 1.270659,10.240246 1.270659,15.997622c0,7.42019 -0.715106,14.282904 -2.076115,20.021056l114.605408,0c4.830813,14.676982 13.18141,24.403966 22.696938,24.403966c14.957642,0 27.085615,-24.000277 27.085615,-53.604143c0,-29.603866 -12.127973,-53.604143 -27.085615,-53.604143c-10.749664,0 -20.005677,12.418245 -24.38282,30.372797l-101.720037,13.069915l52.616066,-197.317455l95.145672,-43.32545l14.057992,197.894154c10.701605,8.254481 18.300572,28.802255 18.300572,52.910182c0,10.690071 -1.522485,20.657347 -4.113784,29.200177l22.026045,0l0,-485.637963l31.107127,11.378265l8.400578,61.710604c9.527062,-91.028043 21.166764,-125.954838 45.85139,-171.087277l44.630711,47.250846l22.746919,-18.375542l-34.125184,-132.125514l19.246357,-39.375064c-105.872267,69.126949 -157.496411,158.372993 -194.247496,277.382456l-94.507458,64.767107l-71.87588,328.16462l0.84198,0c6.09955,0 10.386343,6.036113 12.745041,16.126418l0.75932,3.802367zm385.361596,-665.362264s-10.30945,4.953842 -31.307049,21.585832l14.498205,6.912695l16.808844,-28.498527z"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "AppLogo",
  props: {
    width: {
      type: [Number, String],
      default: 800
    },
    height: {
      type: [Number, String],
      default: 800
    }
  }
}
</script>

<style scoped>
</style>